import React from 'react';
import RecoverableImage from '../../features/images/RecoverableImage';
import { Link } from 'react-router-dom';
import AlbumContentTitle from './AlbumContentTitle';
import { albumPath } from './albumPath';
export function AlbumCard({
  item,
  showRating = true,
  showReleaseDate = false,
  showEmptyRating = false,
  showAdMark = true,
  linkComponent,
  linkProps,
}) {
  const LinkComponent = linkComponent || Link;
  const title = item.title || item.albumTitle;
  const image = item.imageUrl || item.albumImageUrl;
  return (
    <LinkComponent
      className="pp-album-card"
      {...(linkComponent ? linkProps : { to: albumPath(item) })}
    >
      <div className="pp-artwork">
        {image && <RecoverableImage src={image} alt="" loading="lazy" />}
      </div>
      {item.caption && <span className="pp-secondary">{item.caption}</span>}
      <AlbumContentTitle item={item} title={title} />
      {showAdMark && item.isAdMarked && <span className="pp-secondary">AD</span>}
      <span className="pp-secondary pp-content-artist">
        {item.artist?.name || item.artistName || item.albumArtistName || ''}
      </span>
      {showReleaseDate && (item.releaseDate || item.albumReleaseDate) && (
        <span className="pp-secondary pp-content-date">
          {item.releaseDate || item.albumReleaseDate}
        </span>
      )}
      {item.discoveryReason && <span className="pp-secondary">{item.discoveryReason}</span>}
      {item.context && <span className="pp-secondary">{item.context}</span>}
      {showRating &&
        !item.discoveryReason &&
        (showEmptyRating || item.averageRating > 0 || item.albumAvgRating > 0) && (
          <span className="pp-rating">
            ★ {Number(item.averageRating ?? item.albumAvgRating ?? 0).toFixed(1)}
          </span>
        )}
    </LinkComponent>
  );
}
